import * as actionTypes from './../Audit_action.types';
import * as api from './../audit_api_services/vendor.api';

  export const getVendorRequest = () => ({
      type: actionTypes.GET_VENDOR_REQUEST,
  });
  
  export const getVendorSuccess = (clients) => ({
    type: actionTypes.GET_VENDOR_SUCCESS,
    payload: clients,
  });
  
  export const getVendorFailure = (error) => ({
    type: actionTypes.GET_VENDOR_FAILURE,
    payload: error,
  });
  
  export const getVendor = () => {
    return async (dispatch) => {
      dispatch(getVendorRequest());
      try {
        const response = await api.fetchVendor();
        dispatch(getVendorSuccess(response));
        return { success: true, data: response };
      } catch (error) {
        dispatch(getVendorFailure(error));
        return { success: false, message: error };
      }
    };
  };
  
  export const createSingleVendorRequest = (fileData) => ({
      type: actionTypes.CREATE_VENDOR_REQUEST,
      payload: fileData,
  });

export const createSingleVendorSuccess = (fileData) => ({
  type: actionTypes.CREATE_VENDOR_SUCCESS,
  payload: fileData,
});

export const createSingleVendorFailure = (error) => ({
  type: actionTypes.CREATE_VENDOR_FAILURE,
  payload: error,
});

export const createSingleVendor = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadVendorRequest(fileData));
    try {
      const response = await api.addSingleVendor(fileData);
      dispatch(uploadVendorSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(uploadVendorFailure(error));
      return { success: false, message: error };
    }
  };
};
  
export const uploadVendorRequest = (fileData) => ({
    type: actionTypes.UPLOAD_VENDOR_REQUEST,
    payload: fileData,
});

export const uploadVendorSuccess = (fileData) => ({
type: actionTypes.UPLOAD_VENDOR_SUCCESS,
payload: fileData,
});

export const uploadVendorFailure = (error) => ({
type: actionTypes.UPLOAD_VENDOR_FAILURE,
payload: error,
});

export const uploadVendorFile = (fileData) => {
return async (dispatch) => {
  dispatch(uploadVendorRequest(fileData));
  try {
    const response = await api.uploadVendor(fileData);
    dispatch(uploadVendorSuccess(response));
    return { success: true, message: response };
  } catch (error) {
    dispatch(uploadVendorFailure(error));
    return { success: false, message: error };
  }
};
};
  export const multiDaleteVendorRequest = (ids) => ({
    type: actionTypes.MULTIDELETE_VENDOR_REQUEST,
    payload: ids,
  });
  
  export const multiDaleteVendorSuccess = (message) => ({
    type: actionTypes.MULTIDELETE_VENDOR_SUCCESS,
    payload: message,
  });
  
  export const multiDaleteVendorFailure = (error) => ({
    type: actionTypes.MULTIDELETE_VENDOR_FAILURE,
    payload: error,
  });
  
  export const multiDeleteVendor = (ids) => {
    return async (dispatch) => {
      dispatch(multiDaleteVendorRequest(ids));
      try {
        const response = await api.multiDeleteVendor(ids);
        dispatch(multiDaleteVendorSuccess(response));
        return { success: true, message: response };
      } catch (error) {
        dispatch(multiDaleteVendorFailure(error));
        return { success: false, message: error };
      }
    };
  };
  
  
  export const updateVendorRequest = (id, clientData) => ({
    type: actionTypes.UPDATE_VENDOR_REQUEST,
    payload: { id, clientData },
  });
  
  export const updateVendorSuccess = (message) => ({
    type: actionTypes.UPDATE_VENDOR_SUCCESS,
    payload: message,
  });
  
  export const updateVendorFailure = (error) => ({
    type: actionTypes.UPDATE_VENDOR_FAILURE,
    payload: error,
  });
  
  export const updateVendorById = (id, salaryData) => {
    return async (dispatch) => {
      const user = JSON.parse(sessionStorage.getItem('user'));
      salaryData.updated_by = user.user_name;
  
      dispatch(updateVendorRequest(id, salaryData));
      try {
        const response = await api.updateVendor(id, salaryData);
        dispatch(updateVendorSuccess(response.message));
        return { success: true, message: response.message };
      } catch (error) {
        dispatch(updateVendorFailure(error));
        return { success: false, message: error };
      }
    };
  };
  export const deleteVendorRequest = (id) => ({
    type: actionTypes.DELETE_VENDOR_REQUEST,
    payload: id,
  });
  
  export const deleteVendorSuccess = (message) => ({
    type: actionTypes.DELETE_VENDOR_SUCCESS,
    payload: message,
  });
  
  export const deleteVendorFailure = (error) => ({
    type: actionTypes.DELETE_VENDOR_FAILURE,
    payload: error,
  });
  
  export const deleteVendorById = (id) => {
    return async (dispatch) => {
      dispatch(deleteVendorRequest(id));
      try {
        const response = await api.deleteVendor(id);
        dispatch(deleteVendorSuccess(response.message));
        return { success: true, message: response.message };
      } catch (error) {
        dispatch(deleteVendorFailure(error));
        return { success: false, message: error };
      }
    };
  };
  export const vendorLoginRequest = (userData) => ({
    type: actionTypes.VENDOR_LOGIN_REQUEST,
    payload: userData,
  });
  
  export const vendorLoginSuccess = (user) => ({
    type: actionTypes.VENDOR_LOGIN_SUCCESS,
    payload: user,
  });
  
  export const vendorLoginFailure = (error) => ({
    type: actionTypes.VENDOR_LOGIN_FAILURE,
    payload: error,
  });

  
export const vendorLogin = (userData) => {
  return async (dispatch) => {
    dispatch(vendorLoginRequest(userData));
    try {
      const response = await api.vendorLoginUser(userData);
      if (response.status === 200) {
        // sessionStorage.setItem('user', JSON.stringify(response.data.user)); // Save user data to session storage
        // localStorage.setItem('token', response.token); // Save the access token
        dispatch(vendorLoginSuccess(response.data.user));
        return { success: true, token: response.token };
      } else {
        dispatch(vendorLoginFailure(response.message || 'Login failed'));
        return { success: false, message: response.message };
      }
    } catch (error) {
      dispatch(vendorLoginFailure(error || 'An error occurred'));
      return { success: false, message: error };
    }
  };
};



export const vendorForgotPasswordRequest = (userData) => ({
  type: actionTypes.VENDOR_FORGOT_PASSWORD_REQUEST,
  payload: userData,
});

export const vendorForgotPasswordSuccess = () => ({
  type: actionTypes.VENDOR_FORGOT_PASSWORD_SUCCESS,
});

export const vendorForgotPasswordFailure = (error) => ({
  type: actionTypes.VENDOR_FORGOT_PASSWORD_FAILURE,
  payload: error,
});

export const vendorForgotPassword = (userData) => {
  return async (dispatch) => {
    dispatch(vendorForgotPasswordRequest(userData));
    try {
      const response = await api.vendorForgotPassword(userData);
      if (response.status === 200) {
        dispatch(vendorForgotPasswordSuccess());
        return { success: true, message: response.data.message };
      } else {
        return { success: false, message: response.message };
      }

    } catch (error) {
      dispatch(vendorForgotPasswordFailure(error));
      return { success: false, message: error.message || 'An error occurred' };
    }
  };
};

export const vendorLoginReleaseRequest = (ids) => ({
  type: actionTypes.VENDOR_LOGIN_RELEASE_REQUEST,
  payload: ids,
});

export const vendorLoginReleaseSuccess = () => ({
  type: actionTypes.VENDOR_LOGIN_RELEASE_SUCCESS,
});

export const vendorLoginReleaseFailure = (error) => ({
  type: actionTypes.VENDOR_LOGIN_RELEASE_FAILURE,
  payload: error,
});

export const vendorLoginRelease = (ids) => {
  return async (dispatch) => {
    dispatch(vendorLoginReleaseRequest(ids));
    try {
      const response = await api.vendor_login_release(ids);
      if (response.status === 200) {
        dispatch(vendorLoginReleaseSuccess());
        return { success: true, message: response.data.message };
      } else {
        return { success: false, message: response.message };
      }

    } catch (error) {
      dispatch(vendorLoginReleaseFailure(error));
      return { success: false, message: error.message || 'An error occurred' };
    }
  };
};



export const updateVendorPasswordRequest = (vendorData) => ({
    type: actionTypes.VENDOR_UPDATE_REQUEST,
    payload: { vendorData },
  });

  export const updateVendorPasswordSuccess = (message) => ({
    type: actionTypes.VENDOR_UPDATE_SUCCESS,
    payload: message,
  });

  export const updateVendorPasswordFailure = (error) => ({
    type: actionTypes.VENDOR_UPDATE_FAILURE,
    payload: error,
  });

  export const updateVendorPassword = (vendorData) => {
    return async (dispatch) => {
      const user = JSON.parse(sessionStorage.getItem('user'));
      dispatch(updateVendorPasswordRequest(vendorData));
      try {
        const response = await api.updateVendorPassword(vendorData);
        dispatch(updateVendorPasswordSuccess(response.message));
        return { success: true, message: response.message };
      } catch (error) {
        dispatch(updateVendorPasswordFailure(error));
        return { success: false, message: error };
      }
    };
  };


  
// Action Creators
export const uploadVendorProfileRequest = () => ({
  type: actionTypes.VENDOR_PROFILE_UPLOAD_REQUEST,
});

export const uploadVendorProfileSuccess = (message) => ({
  type: actionTypes.VENDOR_PROFILE_UPLOAD_SUCCESS,
  payload: message,
});

export const uploadVendorProfileFailure = (error) => ({
  type: actionTypes.VENDOR_PROFILE_UPLOAD_FAILURE,
  payload: error,
});

// Thunk for uploading profile image
export const uploadVendorProfile = (file) => {
  return async (dispatch) => {
    dispatch(uploadVendorProfileRequest());

    try {
      const formData = new FormData();
      formData.append("profile_image", file);

      const response = await api.uploadVendorProfile(formData);
      dispatch(uploadVendorProfileSuccess(response.message));
      return { success: true, data: response.image_url };
    } catch (error) {
      dispatch(uploadVendorProfileFailure(error));
      return { success: false, message: error };
    }
  };
};



// Fetch profile actions
export const fetchVendorProfileRequest = (vendorId) => ({
  type: actionTypes.VENDOR_PROFILE_FETCH_REQUEST,
});

export const fetchVendorProfileSuccess = (profile) => ({
  type: actionTypes.VENDOR_PROFILE_FETCH_SUCCESS,
  payload: profile,
});

export const fetchVendorProfileFailure = (error) => ({
  type: actionTypes.VENDOR_PROFILE_FETCH_FAILURE,
  payload: error,
});

// Thunk to fetch profile
export const fetchVendorProfiles = () => {
  return async (dispatch) => {
    dispatch(fetchVendorProfileRequest());
    try {
      const response = await api.fetchVendorProfile(); // your api call
      dispatch(fetchVendorProfileSuccess(response.profile || null));
    } catch (error) {
      dispatch(fetchVendorProfileFailure(error));
    }
  };
};


export const getVendorProfileRequest = () => ({
  type: actionTypes.VENDOR_GET_PROFILE_REQUEST,
});

export const getVendorProfileSuccess = (vendor) => ({
  type: actionTypes.VENDOR_GET_PROFILE_SUCCESS,
  payload: vendor,
});

export const getVendorProfileFailure = (error) => ({
  type: actionTypes.VENDOR_GET_PROFILE_FAILURE,
  payload: error,
});

export const getVendorProfile = () => {
    return async (dispatch) => {
      dispatch(getVendorProfileRequest());
      try {
        const vendor = await api.fetchVendorProfiles();
        dispatch(getVendorProfileSuccess(vendor));
        return { success: true, data: vendor };
      } catch (error) {
        dispatch(getVendorProfileFailure(error));
        return { success: false, message: error };
      }
    };
  };



